import { useReducer, useEffect } from "react";
import fetchLatestLogsReducer, { initialState } from "./reducer";
import { fetchLatestLogs } from "./api";
import ACTIONS from "./actions";

async function fetchLatestLogsDetails(dispatch, chargerId, startDate, endDate) {
  dispatch({ type: ACTIONS.FETCH_LATEST_LOGS_INIT });
  try {
    await fetchLatestLogs(chargerId, startDate, endDate);
    dispatch({ type: ACTIONS.FETCH_LATEST_LOGS_SUCCESS });
  } catch (error) {
    dispatch({ type: ACTIONS.FETCH_LATEST_LOGS_FAILURE });
  }
}

function useLatestLogsReducer(chargerId, startDate, endDate) {
  const [state, dispatch] = useReducer(fetchLatestLogsReducer, initialState);

  useEffect(() => {
    if (chargerId && startDate.length && endDate.length) {
      fetchLatestLogsDetails(dispatch, chargerId, startDate, endDate);
    }
  }, [chargerId, startDate, endDate]);

  // return only the status (step chart) slice to preserve previous hook API
  return {
    state,
  };
}

export default useLatestLogsReducer;
